import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Navbar.css';

const LogoutButton = ({ handleLogout }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    handleLogout();
    // Redirect to login page after logout
    navigate('/admin/login');
  };

  return (
    <Link to="/" className='nav-links' onClick={handleClick}>
      LOGOUT
    </Link>
  );
};

export default LogoutButton;